module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAtCAMAAACDHlvUAAAAUVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////8IN+deAAAAGnRSTlMA89ocGWzvtZtO3+rk00U8NjEmIgTwo3NVTxM8HaQAAADQSURBVDjL7ZJZEsMgDEOFTaAh+9aF+x+0DRiSKZMTtO/LgzASBghcWVKKbMU4o28+c9PI1MqfUDWEyn9RyX5fEHq0KgW1+0RfI0tNFxMAHIpu7UMj6TVuYXFuNIaP4hh98rexIMZo2mWXAxbkI27BNGNMSQg5UzsDk8m5DsFMwNweAqVqxDxhcfkoK+sDltaMYBLzNKge7IKsG4nL0WDVFBr7NV6d00i6JmVIIwFvF0PEqxTqy4cSnlvxtIK+F58hSw/rvHyfAo+dv/BLAuHEG+8EJ1fL0tlbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/transfer/close.png
// module id = odVF
// module chunks = 36